import apiClient from './apiClient';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const authService = {
  /**
   * Inscription d'un nouvel utilisateur
   */
  async register(email, password, displayName = null) {
    const response = await apiClient.post('/auth/register', {
      email,
      password,
      displayName
    });

    const { token, user } = response.data;
    this.setSession(token, user);

    return user;
  },

  /**
   * Connexion utilisateur
   */
  async login(email, password) {
    const response = await apiClient.post('/auth/login', {
      email,
      password
    });

    const { token, user } = response.data;
    this.setSession(token, user);

    return user;
  },

  /**
   * Déconnexion
   */
  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  /**
   * Récupérer l'utilisateur courant depuis l'API
   */
  async getCurrentUser() {
    const response = await apiClient.get('/auth/me');
    const user = response.data;

    localStorage.setItem(USER_KEY, JSON.stringify(user));

    return user;
  },

  /**
   * Mettre à jour le profil
   */
  async updateProfile(displayName, preferences) {
    const response = await apiClient.put('/auth/me', {
      displayName,
      preferences
    });

    const user = response.data;
    localStorage.setItem(USER_KEY, JSON.stringify(user));

    return user;
  },

  /**
   * Changer le mot de passe
   */
  async changePassword(currentPassword, newPassword) {
    await apiClient.put('/auth/password', {
      currentPassword,
      newPassword
    });
  },

  /**
   * Vérifie si l'utilisateur est connecté
   */
  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Récupérer le token stocké
   */
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Récupérer l'utilisateur stocké localement
   */
  getStoredUser() {
    const userStr = localStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Sauvegarder la session
   */
  setSession(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  /**
   * Vérifier et rafraîchir la session si nécessaire
   */
  async checkSession() {
    if (!this.isAuthenticated()) {
      return null;
    }

    try {
      return await this.getCurrentUser();
    } catch (error) {
      // Token invalide ou expiré
      this.logout();
      return null;
    }
  }
};

export default authService;
